<template>
  <div class="school-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" />
    <MilkSchoolListComponent
      v-if="pageData"
      :page-data="pageData"
      @view="view"
      @edit="edit"
      @invalid="invalid"
      @active="active"
      @remove="remove"
      @onSelectChanged="onSelectChanged"
      @onPageChanged="onPageChanged" />
    <el-dialog :title="schoolData.id ? (schoolDialog.canEdit ? '修改学校' : '学校详情') : '新增学校'" :visible.sync="schoolDialog.showEditDialog" width="80%" @closed="hideSchoolEditDialog" :close-on-click-modal="false">
      <el-form :model="schoolData" :rules="rules" :disabled="!schoolDialog.canEdit">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">基本信息</span>
          </div>
          <div class="text item">
            <el-form-item label="学校名称" label-width="120px" prop="title">
              <el-col :span="12">
                <el-input type="text" v-model="schoolData.title" maxlength="30" show-word-limit></el-input>
              </el-col>
            </el-form-item>
            <el-form-item required label="所在地区" prop="area" label-width="120px">
              <el-col :span="8">
                <el-cascader ref="areaPicker" class="area-picker" placeholder="请选择地区" :props="areas" v-model="schoolData.area" @change="onAreaPick"></el-cascader>
              </el-col>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="title">关联班级</span>
          </div>
          <div class="text item">
            <el-form-item>
              <el-col :span="24">
                <el-table :data="schoolData.classes" border style="width: 100%">
                  <el-table-column label="年级" width="150" fixed header-align="center" align="center">
                    <template slot-scope="scope">
                      <el-input type="text" v-model="scope.row.className"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="班级" header-align="center">
                    <template slot-scope="scope">
                      <el-row :gutter="5">
                        <el-col style="margin-bottom: 5px" :span="6" v-for="(item,index) in scope.row.items" :key="'item-' + index">
                          <el-input type="text" v-model="item.name">
                            <el-button slot="append" icon="el-icon-delete" @click="removeItem(scope.$index, index)"></el-button>
                          </el-input>
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200" fixed="right" header-align="center" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="addItem(scope.$index)">添加班级</el-button>
                      <el-button type="text" size="small" @click="removeClass(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-form-item>
            <el-form-item><el-col :span="24"><el-button plain @click="addClass">添加年级</el-button></el-col></el-form-item>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="schoolDialog.showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveschool" v-if="schoolDialog.canEdit" :disabled="schoolDialog.disabled">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import {MilkRequestUtil} from '../../../utils/MilkRequestUtil'
import {MessageUtil} from '../../../utils/MessageUtil'
import MilkSchoolListComponent from '../../../components/school/MilkSchoolListComponent'

export default {
  name: 'MilkSchoolListPage',
  components: {
    MilkSchoolListComponent,
    OperationBoxComponent
  },
  mounted () {
    this.updateSchoolList()
  },
  data () {
    let that = this
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateSchoolList },
        { title: '新增学校', disabled: false, type: 'button', theme: 'primary', action: this.showSchoolEditDialog },
        { title: '启用', disabled: () => { return that.params.ids.length === 0 }, type: 'button', theme: 'success', action: this.batchActive },
        { title: '禁用', disabled: () => { return that.params.ids.length === 0 }, type: 'button', theme: 'warning', action: this.batchInvalid },
        { title: '删除', disabled: () => { return that.params.ids.length === 0 }, type: 'button', theme: 'danger', action: this.batchRemove },
        { title: '学校状态',
          type: 'select',
          action: this.onAuditStateChange,
          options: [
            {title: '全部', value: 0},
            {title: '启用中', value: 1},
            {title: '已禁用', value: 2}
          ]}
      ],
      areas: {
        lazy: true,
        lazyLoad (node, resolve) {
          MilkRequestUtil.queryArea({parentId: node.value}, (items) => {
            const nodes = items.map(item => ({
              value: item.id,
              label: item.name,
              leaf: item.has_children !== '1'
            }))
            resolve(nodes)
          })
        }
      },
      filters: [{searchValue: '', type: 'title', title: '学校名称', options: [{title: '学校名称', value: 'title'}], action: this.onFilterChange}],
      rules: {
        title: [{required: true, message: '学校名称不能为空'}],
        area: [{required: true, message: '所在区域不能为空', validator: () => {}}]
      },
      pageData: {},
      params: {
        ids: []
      },
      queryParam: {
        page: 1,
        pageSize: 25,
        status: null,
        keywords: null
      },
      schoolData: {
        id: '',
        title: '',
        area: [],
        province: '',
        city: '',
        county: '',
        classes: []
      },
      schoolDialog: {
        showEditDialog: false,
        canEdit: true,
        prevImages: [],
        disabled: false
      }
    }
  },
  methods: {
    onAreaPick (area) {
      if (area) {
        this.schoolData.province = area[0]
        this.schoolData.city = area[1]
        this.schoolData.county = area[2]
        this.schoolData.area = area
      }
      console.log(this.schoolData)
    },
    addClass () {
      this.schoolData.classes.push({className: '', items: []})
    },
    removeClass (classIndex) {
      let that = this
      MessageUtil.tipsConfirm('确认删除此年级？', 'warning', () => { that.schoolData.classes.splice(classIndex, 1) })
    },
    addItem (classIndex) {
      this.schoolData.classes[classIndex].items.push({name: ''})
    },
    removeItem (classIndex, index) {
      let that = this
      MessageUtil.tipsConfirm('确认删除此班级？', 'warning', () => { that.schoolData.classes[classIndex].items.splice(index, 1) })
    },
    checkClassNameRepeat () {
      const classes = this.schoolData.classes.map(item => (item.className))
      const newClasses = [...new Set(classes)]
      if (classes.length === 0) {
        this.$message.error('必须设置年级')
        return false
      }
      for (let i in classes) {
        if (classes[i] === '') {
          this.$message.error('年级名称不能为空')
          return false
        }
      }
      if (classes.length !== newClasses.length) {
        this.$message.error('存在重复的年级名称')
        return false
      }
      return true
    },
    checkClassItemRepeat (classIndex) {
      let items = this.schoolData.classes[classIndex].items.map(item => (item.name))
      if (items.length === 0) {
        this.$message.error('年级下面必须设置班级')
        return false
      }
      let newClassItems = [...new Set(items)]
      for (let i in items) {
        if (items[i] === '') {
          this.$message.error('班级名称不能为空')
          return false
        }
      }
      if (items.length !== newClassItems.length) {
        this.$message.error('存在重复的班级名称')
        return false
      }
      return true
    },
    showSchoolEditDialog (schoolData, canEdit = true) {
      let that = this
      if (schoolData.id) {
        this.schoolData = schoolData
        setTimeout(() => {
          that.schoolDialog.canEdit = canEdit
        }, 100)
      }
      this.schoolDialog.showEditDialog = true
    },
    hideSchoolEditDialog () {
      this.schoolData = {classes: []}
      this.schoolDialog.showEditDialog = false
      this.schoolDialog.canEdit = true
    },
    updateSchoolList () {
      let that = this
      this.pageData = {}
      MilkRequestUtil.querySchoolList({queryParam: this.queryParam}, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    onAuditStateChange (item) {
      this.queryParam.page = 1
      this.queryParam.status = parseInt(item.selectValue)
      this.updateSchoolList()
    },
    onFilterChange (item) {
      this.queryParam.page = 1
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateSchoolList()
    },
    view (param) {
      console.log('xxx')
      this.showSchoolEditDialog(param, param.status === 2)
    },
    edit (param) {
      this.showSchoolEditDialog(param)
    },
    active (param) {
      MessageUtil.tipsConfirm('确认启用此学校？', 'warning', () => { MilkRequestUtil.activeSchool(param, this.updateSchoolList) })
    },
    invalid (param) {
      MessageUtil.tipsConfirm('确认禁用此学校？', 'warning', () => { MilkRequestUtil.invalidSchool(param, this.updateSchoolList) })
    },
    remove (param) {
      MessageUtil.tipsConfirm('确认删除此学校？', 'warning', () => { MilkRequestUtil.removeSchool(param, this.updateSchoolList) })
    },
    batchActive () {
      MessageUtil.tipsConfirm('确认启用选中的学校？', 'warning', () => { MilkRequestUtil.activeSchool({id: this.params.ids}, this.updateSchoolList) })
    },
    batchInvalid () {
      MessageUtil.tipsConfirm('确认禁用选中的学校？', 'warning', () => { MilkRequestUtil.invalidSchool({id: this.params.ids}, this.updateSchoolList) })
    },
    batchRemove () {
      MessageUtil.tipsConfirm('确认删除选中的学校？', 'warning', () => { MilkRequestUtil.removeSchool({id: this.params.ids}, this.updateSchoolList) })
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateSchoolList()
    },
    saveschool () {
      let that = this
      if (!this.schoolData.title) {
        return this.$message.error('学校名称不能为空')
      }
      if (!this.schoolData.province) {
        return this.$message.error('省份不能为空')
      }
      if (!this.schoolData.city) {
        return this.$message.error('城市不能为空')
      }
      if (!this.schoolData.county) {
        return this.$message.error('区/县不能为空')
      }
      if (!this.schoolData.classes || this.schoolData.classes.length === 0) {
        return this.$message.error('必须设置年级')
      }
      if (!this.checkClassNameRepeat()) {
        return
      }
      for (let i in this.schoolData.classes) {
        if (!this.checkClassItemRepeat(i)) {
          return
        }
      }
      this.schoolDialog.disabled = true
      MilkRequestUtil.saveSchoolInfo(this.schoolData, (response) => {
        if (response.result) {
          this.$message.success('操作成功')
          that.updateSchoolList()
          that.hideSchoolEditDialog()
        }
        that.schoolDialog.disabled = false
      })
    }
  }
}
</script>

<style scoped lang="less">

.box-card {
  margin-bottom: 10px;

  .title {
    font-weight: bold;
  }

  .area-picker{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/milk/school/MilkSchoolListPage.vue